import React, { useEffect } from 'react';

function TeeTimes() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://app.getgolfmarshal.com/widget/mg2-tee.js";
    script.async = true;
    script.crossOrigin = "anonymous";
    script.setAttribute('data-tenant', '680231bed87c5cc321656af7');
    script.setAttribute('data-token', 'SIGNED_TOKEN_SAMPLE');
    script.integrity = 'sha384-...';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="container mx-auto px-4 py-6">
      <mg2-tee-booker data-tenant="680231bed87c5cc321656af7"></mg2-tee-booker>
    </div>
  );
}

export default TeeTimes;


